<template>
    <div>
        <v-layout>
            <v-flex>
                <div id="reportList" v-if="display=='report'">
                    <v-layout wrap>
                        <v-flex xs12 sm12 md12 lg12 xl12 style="margin: auto">
                            <div id="divStudents">
                                <v-data-table :headers="reportHeaders" :items="reports" class="elevation-1" :pagination.sync="pagination">
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-left">{{ props.index + parseInt(pagination.page-1) *
                                            parseInt(pagination.rowsPerPage) +1 }}</td>
                                        <td class="text-xs-left">{{getReportType( props.item.reportType )}}</td>
                                        <td class="text-xs-left">{{ props.item.reportName }}</td>
                                        <td class="text-xs-left" v-if="$store.state.auth.user.role!=2">{{ props.item.reportDate | formatDateTime }}</td>
                                        <td class="text-xs-left" v-if="$store.state.auth.user.role!=2">{{ getReportStatus(props.item.status)}}</td>
                                        <td class="justify-center layout px-0">
                                            <v-btn @click="viewReport(props.item)" class="mx-0" icon>
                                                <v-icon class="primaryColor">visibility</v-icon>
                                            </v-btn>
                                            <v-btn @click="updateReport(props.item)" class="mx-0" icon v-if="$store.state.auth.user.role==4">
                                                <v-icon color="pink">edit</v-icon>
                                            </v-btn>
                                        </td>
                                    </template>
                                </v-data-table>
                            </div>
                        </v-flex>
                    </v-layout>
                </div>
                <div id="memberList" v-else-if="display=='list'">
                    <v-layout class="reportPanel" style="background-color: white">
                        <v-flex xs4 sm4 md4 lg4 xl4 style="text-align: center;">
                            <div class="label">
                                ĐIỂM TRUNG BÌNH
                            </div>
                            <div class="content" style="font-size: 50px;font-weight: bold;text-align: center;margin-top:10px">
                                {{averateMark}}
                            </div>
                        </v-flex>
                        <v-flex xs8 sm8 md8 lg8 xl8>
                            <canvas id="mark-lesson-report-chart"/>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm12 md12 lg12 xl12>
                            <v-data-table :headers="exerciseReportHeaders" class="elevation-1"
                                          :items="exerciseReport" hide-actions locale="vi">
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">{{ props.index+1}}</td>
                                    <td class="text-xs-left">{{ props.item["userName"] }}</td>
                                    <td class="text-xs-right">
                                        <div v-if="editReport==false">
                                            {{ props.item["mark"] }}
                                        </div>
                                        <input class="tableInput" v-else type="text" style="text-align: right"
                                               v-model='props.item["mark"]'/>

                                    </td>
                                    <td class="text-xs-right">{{ props.item["rank"]}}</td>
                                    <td class="text-xs-left">
                                        <div v-if="editReport==false">
                                            {{ props.item["teacherComment"] }}
                                        </div>
                                        <input class="tableInput" v-else type="text"
                                               list="commentSuggest"
                                               v-model='props.item["teacherComment"]'/>
                                    </td>
                                    <td class="text-xs-left">
                                        <div v-if="editReport==false">
                                            {{ props.item["teacherCommentImprove"] }}
                                        </div>
                                        <input class="tableInput" v-else type="text"
                                               list="attitudeCommentSuggest"
                                               v-model='props.item["teacherCommentImprove"]'/>
                                    </td>
                                </template>
                            </v-data-table>
                            <datalist id="commentSuggest">
                                <option value="Tốt"/>
                                <option value="Rất tốt"/>
                            </datalist>
                            <datalist id="attitudeCommentSuggest">
                                <option value="Rất nghiêm túc"/>
                                <option value="Nghiêm túc"/>
                                <option value="Thiếu tích cực"/>
                            </datalist>

                        </v-flex>
                    </v-layout>
                    <div style="text-align: right">
                        <v-btn color="primary" @click="onExportReport">
                            {{$t('lang.common.exportReport') }}
                        </v-btn>
<!--
                        <v-btn class="orange" dark @click="onSendEmail">
                            {{$t('lang.common.sendEmail')}}
                        </v-btn>
-->
                        <v-btn class="blue" dark @click="onSend" v-if="!editReport && $store.state.auth.user.role==4">
                            {{$t('lang.class.send')}}
                        </v-btn>
                        <v-btn class="yoprimary" dark @click="editReport = true" v-if="!editReport && $store.state.auth.user.role==4">
                            {{$t('lang.common.edit')}}
                        </v-btn>
                        <v-btn @click="saveReport()" v-if="editReport && $store.state.auth.user.role==4"
                               class="yoprimary" dark>
                            {{$t('lang.common.save')}}
                        </v-btn>
                        <v-btn @click="closeDetail()" color="red" dark>
                            {{$t('lang.common.back')}}
                        </v-btn>
                    </div>
                </div>
                <send-to-member :class-id="classId" :exercise-id="workingReport==null?null:workingReport.exerciseId" :exercise-type="workingReport==null?null:workingReport.exerciseType" @send="onChangeReceiver" ref="sendDialog" :selectable="false"/>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import SendToMember from "../sendToMember";

    export default {
        name: "lesson-report-page",
        components: {SendToMember},
        props: {
            classId: {
                type: String | Number,
                default: null
            }
        },

        data: () => ({
            display: "report",
            editReport: false,
            month: "",
            studentHeaders: [
                {
                    text: "Sinh viên",
                    align: "left",
                    sortable: false,
                    value: "fullName"
                },
                {
                    text: "email",
                    align: "left",
                    sortable: false,
                    value: "email"
                },
                {text: "Báo cáo chi tiết", value: "name", align: "center", sortable: false}
            ],
            students: [],
            exerciseReportHeaders: [
                {
                    text: "STT",
                    align: "left",
                    sortable: false,
                    value: "index"
                },
                {
                    text: "Họ Tên",
                    align: "left",
                    sortable: false,
                    value: "question"
                },
                {
                    text: "Điểm",
                    align: "right",
                    sortable: false,
                    value: "mark"
                },
                {
                    text: "Xếp hạng",
                    align: "right",
                    sortable: false,
                    value: "rank"
                },
                {
                    text: "Nhận xét bài tập",
                    align: "left",
                    sortable: false,
                    value: "teacherComment"
                },
                {
                    text: "Nhận xét thái độ học tập",
                    align: "left",
                    sortable: false,
                    value: "teacherCommentImprove"
                }
            ],
            exerciseReport: [],
            workingReport: null,
            reports: [],
            exerciseId: null,
            exerciseType: null,
            averateMark: null,
            pagination: {
                rowsPerPage: 10,
                page: 1,
                totalItems: 0,
            },
        }),

        computed: {
            reportHeaders(){
                if(this.$store.state.auth.user.role==2){
                    return [
                        {
                            text: "STT",
                            align: "left",
                            sortable: false,
                            value: "index"
                        },
                        {
                            text: "Loại báo cáo",
                            align: "left",
                            sortable: false,
                            value: "reportType"
                        },
                        {
                            text: "Tên báo cáo",
                            align: "left",
                            sortable: false,
                            value: "reportName"
                        },
                        {
                            text: "Xử lý",
                            align: "center",
                            sortable: false,
                            value: "status"
                        }
                    ];
                } else {
                    return [
                        {
                            text: "STT",
                            align: "left",
                            sortable: false,
                            value: "index"
                        },
                        {
                            text: "Loại báo cáo",
                            align: "left",
                            sortable: false,
                            value: "reportType"
                        },
                        {
                            text: "Tên báo cáo",
                            align: "left",
                            sortable: false,
                            value: "reportName"
                        },
                        {
                            text: "Thời gian cập nhật",
                            align: "center",
                            sortable: false,
                            value: "reportDate"
                        },
                        {
                            text: "Trạng thái",
                            align: "left",
                            sortable: false,
                            value: "status"
                        },
                        {
                            text: "Xử lý",
                            align: "left",
                            sortable: false,
                            value: "status"
                        }
                    ];
                }
            }
        },

        watch: {
            classId: function (data) {
                this.getLessonReportList();
            },
            month: function (data) {
                console.log(data);
            }
        },

        created() {
            this.getLessonReportList();
        },
        methods: {
            getReportType: function (type) {
                let typeName = "";
                switch (type) {
                    case 0:
                        typeName = "Báo cáo sau bài tập";
                        break;
                    case 1:
                        typeName = "Báo cáo cá nhân";
                        break;
                    case 2:
                        typeName = "Báo cáo tháng";
                        break;
                    case 3:
                        typeName = "Báo cáo quý";
                        break;
                }
                return typeName;
            },
            getReportStatus: function (status) {
                let name = "";
                switch (status) {
                    case 0:
                        name = "Chưa cập nhật";
                        break;
                    case 1:
                        name = "Đã cập nhật";
                        break;
                    case 2:
                        name = "Đã gửi";
                        break;
                }
                return name;

            },
            getLessonReportList: function () {
                if (this.classId == null) {
                    return;
                }
                axios
                    .post(
                        process.env.VUE_APP_API_URL +
                        "/report/listLessonReport?classId=" +
                        this.classId
                    )
                    .then(
                        data => {
                            this.reports = data;
                        },
                        error => {
                        }
                    )

            },
            viewReport: function (report) {
                this.exerciseId = report.exerciseId;
                this.exerciseType = report.exerciseType;
                this.editReport = false;
                this.display = "list";
                this.workingReport = report;
                this.getMarkReport();
                this.getListStudentMark();

            },
            updateReport: function (report) {
                this.exerciseId = report.exerciseId;
                this.exerciseType = report.exerciseType;
                this.editReport = true;
                this.display = "list";
                this.workingReport = report;
                this.getMarkReport();
                this.getListStudentMark();
            },
            getClassMembers: function () {
                if (this.classId == null) {
                    return;
                }
                axios
                    .get(
                        process.env.VUE_APP_API_URL +
                        "/classmember/myStudents?classId=" +
                        this.classId
                    )
                    .then(
                        data => {
                            this.students = data;
                        },
                        error => {
                        }
                    )
            },

            getMarkReport: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/getMarkReportOfExercise?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            this.mapMark = data;
                            this.averateMark = data[0];
                            const ctxmark = document.getElementById('mark-lesson-report-chart');
                            const chartmark = new Chart(ctxmark, {
                                type: 'pie',
                                data: {
                                    labels: ["<6.5", "6.5-8", "≥8"],
                                    datasets: [
                                        {
                                            data: [this.mapMark[6], this.mapMark[8], this.mapMark[10]],
                                            backgroundColor: [
                                                '#36a2eb',
                                                'orange', // Blue
                                                '#ffcd56',
                                                '#ff6384'
                                            ],
                                        }
                                    ]
                                },
                                options: {
                                    title: {
                                        display: true,
                                        text: 'Biểu đồ thống kê điểm cùa học sinh'
                                    }
                                },
                            });

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            getStudentMark: function (userId) {
                this.display = "detail";
                axios.post(process.env.VUE_APP_API_URL + "/exercise/getStudentMark?classId=" + this.classId + "&userId=" + userId)
                    .then(
                        data => {
                            this.exerciseReport = data;
                            const ctxmark = document.getElementById('member-mark-report-chart');
                            let label = [];
                            let markData = [];
                            let max = 0;
                            for (let i = 0; i < this.exerciseReport.length; i++) {
                                label.push(this.exerciseReport[i].endTime);
                                markData.push(this.exerciseReport[i].mark);
                                if (this.exerciseReport[i].mark > max) {
                                    max = this.exerciseReport[i].mark;
                                }
                            }
                            console.log(label);
                            console.log(markData);
                            console.log(max);
                            const chartmark = new Chart(ctxmark, {
                                type: 'line',
                                data: {
                                    labels: label,
                                    datasets: [
                                        {
                                            label: "Biểu đồ điềm",
                                            borderColor: 'orange',
                                            borderWidth: 1,
                                            data: markData,
                                        }
                                    ]
                                },
                                options: {
                                    title: {
                                        display: true,
                                        text: 'Biểu đồ thống kê điểm cùa học sinh'
                                    },
                                    scales: {
                                        yAxes: [{
                                            display: true,
                                            ticks: {
                                                suggestedMin: 0, //min
                                                suggestedMax: max //max
                                            }
                                        }]
                                    }
                                },
                            });

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            getListStudentMark: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/getListStudentMark?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            this.exerciseReport = data;
                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onExportReport: function () {
                let url = process.env.VUE_APP_API_URL + "/exercise/exportWord?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType;
                window.location.href = url;
            },

/*
            onSendEmail: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/sendReport?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Gửi mail thành công");
                            } else {
                                message.error("Gửi mail không thành công");
                            }

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onSendZalo: function () {
                //let url = encodeURIComponent("https://localhost:8082/#/sendZalo/");
                let url = process.env.VUE_APP_FRONTEND_URL + "/#/sendZalo";
                console.log(url);
                let state = this.classId + "_" + this.exerciseId + "_" + this.exerciseType;
                url = encodeURIComponent(url);
                console.log(url);
                window.location.href = "https://oauth.zaloapp.com/v3/permission?app_id=2865613710705099529&redirect_uri=" + url + "&state=" + state;
            },
*/

            saveReport: function () {
                console.log(this.exerciseReport);
                axios.post(process.env.VUE_APP_API_URL + "/exercise/updateStudentMark?", this.exerciseReport)
                    .then(
                        data => {
                            if (data.success) {
                                axios.post(process.env.VUE_APP_API_URL + "/report/saveReport?", this.workingReport).then(
                                    saveResult => {
                                        if (saveResult.success) {
                                            message.success(this.$t('lang.common.save_success'));
                                            this.workingReport = saveResult.ref;
                                            this.editReport = false;
                                            this.getMarkReport();
                                            this.getListStudentMark();
                                        }
                                    },

                                    saveError => {
                                        message.error(saveError);

                                    }
                                );

                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    )

            },

            closeDetail: function () {
                this.display = "report";
                this.getLessonReportList();
            },

            onSendSMS: function () {
                axios.post(process.env.VUE_APP_API_URL + "/report/sendLessonSMSReport?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Gửi SMS thành công");
                            } else {
                                message.error("Gửi SMS không thành công");
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onSendEmail: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/sendReport?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Gửi mail thành công");
                            } else {
                                message.error("Gửi mail không thành công");
                            }

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onSendZalo: function () {
                //let url = encodeURIComponent("https://localhost:8082/#/sendZalo/");
                let url = process.env.VUE_APP_FRONTEND_URL + "/#/sendZalo";
                console.log(url);
                let state = this.classId + "_" + this.exerciseId + "_" + this.exerciseType;
                url = encodeURIComponent(url);
                console.log(url);
                window.location.href = "https://oauth.zaloapp.com/v3/permission?app_id=2865613710705099529&redirect_uri=" + url + "&state=" + state;
            },

            onSend: function(){
                this.$refs.sendDialog.show();
            },

            onChangeReceiver: function(receivers){
                axios.post(process.env.VUE_APP_API_URL+"/report/sendReport",this.workingReport).then(
                    data=>{
                        if(data.success){
                            this.onSendEmail();
                            this.onSendSMS();
                            //this.onSendZalo();
                            this.workingReport = data.ref;
                            this.$refs.sendDialog.close();
                        }
                    }
                )
            },

        }
    };
</script>